module.exports = __webpack_public_path__ + "media/npc_dota_hero_slark.2b4757b2.webm";